import { useMemo } from "react";
import Card, { CardHeader } from "components/card";
import Chart from "components/charts/Chart";
import { ARCHETYPE_CHART_COLORS, ARCHETYPE_KEYS, ARCHETYPES } from "lib/archetypes";

const OPTIONS = {
  labels: ARCHETYPE_KEYS.map((key) => ARCHETYPES[key].label),
  colors: ARCHETYPE_CHART_COLORS,
  legend: { position: "bottom", horizontalAlign: "center" },
  dataLabels: { enabled: true },
  plotOptions: { pie: { donut: { size: "55%" } } },
};

const ArchetypeDistribution = ({ distribution }) => {
  const series = useMemo(
    () => ARCHETYPE_KEYS.map((key) => Number(distribution?.[key]) || 0),
    [distribution]
  );

  if (!distribution) return null;

  return (
    <Card padding="md">
      <CardHeader title="Archetype Distribution" className="mb-4" />
      <Chart
        type="donut"
        series={series}
        options={OPTIONS}
        height="lg"
        emptyText="No completed assessments yet"
      />
    </Card>
  );
};

export default ArchetypeDistribution;
